/** @jsx jsx */
import { jsx, Flex } from 'theme-ui'
import React from 'react'
import Seperator from '../../components/shared/Separator/Separator'
import Link from '../../components/shared/Typography/Link/Link'
import AmazonLogo from '../../icons/AmazonLogo.svg'
import AmexLogo from '../../icons/AmexLogo.svg'
import MastercardLogo from '../../icons/MastercardLogo.svg'
import PaypalLogo from '../../icons/PaypalLogo.svg'
import VisaLogo from '../../icons/VisaLogo.svg'
import { HideOnDestop, mobile } from '../../components/shared/index'
import styled from '@emotion/styled'
import Body from '../../components/shared/Typography/Body/Body'
import { css } from '@emotion/core'
import { useWindowSize } from '../../hooks/useWindowSize'
import TrustPilot from '../TrustPilot'

const Logo = styled.img`
  width: 38px;
  margin: 0px 5px 0px 5px;
  ${mobile(css`
    width: 45px;
  `)}
`

const ImgWrapper = styled.div`
  display: flex;
  justify-content: center;
`

export const PaymentLogos = props => {
  return (
    <ImgWrapper {...props}>
      <Logo src={AmazonLogo} alt={'amazon'} />
      <Logo src={AmexLogo} alt={'AmexLogo'} />
      <Logo src={MastercardLogo} alt={'amazonMastercardLogo'} />
      <Logo src={PaypalLogo} alt={'PaypalLogo'} />
      <Logo src={VisaLogo} alt={'VisaLogo'} />
    </ImgWrapper>
  )
}

const BottomMiscFooter = props => {
  const { mobile } = useWindowSize()
  return (
    <Flex
      sx={{
        flexDirection: ['row'],
        alignItems: 'center',
        flexWrap: 'wrap',
        justifyContent: ['space-between'],
        py: '15px',
      }}
    >
      {!mobile && (
        <TrustPilot
          data-style-height="24px"
          data-style-width="280px"
          data-theme="light"
          style={{ flex: 1, fontWeight: 'bold' }}
        />
      )}

      <PaymentLogos
        sx={{
          justifyContent: ['center', null, 'flex-start', 'center'],
          alignItems: ['center'],
          flex: 1,
          width: ['100%', 'auto', 'auto', 'auto'],
        }}
      />
      <HideOnDestop sx={{ width: ['100%'] }}>
        <Seperator sx={{ width: ['100%'], mt: '15px' }} />
      </HideOnDestop>
      <Flex
        sx={{
          justifyContent: ['space-between', null, 'flex-end', 'flex-end'],
          width: ['100%', '100%', '30%'],
          pr: 10,
          flex: 1,
        }}
      >
        <Flex>
          <Link sx={{ mx: 10 }} to="privacy-policy">
            <Body variant="miscLinkText">Privacy</Body>
          </Link>
          <Link sx={{ mx: 10 }} to="terms-and-condition">
            <Body variant="miscLinkText">Terms</Body>
          </Link>
          <Link sx={{ mx: 10 }} data-acsb-custom-trigger="true">
            <Body variant="miscLinkText">Accessibility</Body>
          </Link>
        </Flex>
        <Body sx={{ ml: 10 }} variant="miscLinkText">
          © 2020 JAXXON
        </Body>
      </Flex>
    </Flex>
  )
}

export default BottomMiscFooter
